import React, { useMemo, useState, useEffect } from "react";
import {
    Card, CardBody, CardHeader, Badge, Button, Progress,
    ListGroup, ListGroupItem, Row, Col
} from "reactstrap";
import { FaCheck, FaTimes, FaPaperclip } from "react-icons/fa";

export default function DocumentCheckListReadOnly({ supportTypeId, docs }) {

    return (
        <>
            <Card className="shadow-sm border-0 rounded-4">


                <CardBody>


                    <ListGroup flush>
                        {docs.map((doc) => {
                            // const isOn = !!checked[doc.id];
                            return (
                                <ListGroupItem
                                    key={doc.id}
                                    className="d-flex align-items-center justify-content-between py-3 px-3 rounded-3 checklist-item"
                                >
                                    <div className="d-flex align-items-center gap-3">
                                        <button
                                            type="button"
                                            className={`checkbox-pill on`}
                                            aria-pressed={true}
                                            aria-label={`toggle ${doc.label}`}
                                        // onClick={() => toggleOne(doc.id)}
                                        >
                                            <FaCheck />
                                        </button>

                                        <div className="fw-semibold">{doc}</div>
                                    </div>
                                </ListGroupItem>
                            );
                        })}
                    </ListGroup>
                </CardBody>

                {/* สไตล์เฉพาะปุ่มเช็ก */}
                <style>{`
       .checkbox-pill {
         width: 42px;
         height: 42px;
         border-radius: 999px;
         border: 2px solid #dee2e6;
         background: #fff;
         display: inline-flex;
         align-items: center;
         justify-content: center;
         font-size: 1rem;
         transition: all .2s ease;
       }
       .checkbox-pill:hover {
         transform: translateY(-1px);
         box-shadow: 0 4px 14px rgba(0,0,0,.08);
       }
       .checkbox-pill.on {
         background: #198754;
         border-color: #198754;
         color: #fff;
       }
       .checklist-item {
         background: #fff;
         border: 1px solid #f1f3f5;
         margin-bottom: .5rem;
       }
       .checklist-item:last-child {
         margin-bottom: 0;
       }
     `}</style>
            </Card>
        </>
    );
}
